"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSideBar = exports.StyledTableBody = exports.StyledTable = exports.StyledRow = exports.StyledTableContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _knotchincWebReactComponentsUtils = require("@bit/knotchinc.web-react-components.utils.styled-helpers");

var _styled = require("./Cell/styled.js");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  padding: 16px;\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n  bottom: ", "px;\n  width: ", "px;\n  background: #F3F4F5;\n  z-index: 2;\n  border-radius: 5px;\n  overflow: hidden;\n\n  @media (min-width: 1300px) {\n    width: ", "px;\n  }\n\n  @media (min-width: 1500px) {\n    width: ", "px;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    height: auto;\n\n    .scrollbar-container {\n      padding: 0;\n    }\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: ", ";\n\n  .scrollbar-container {\n    padding: 6px;\n  }\n\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n    height: auto;\n    position: relative;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: ", "px;\n    left: ", "px;\n    bottom: ", "px;\n    right: ", ";\n\n    @media (min-width: 1300px) {\n      right: ", ";\n    }\n\n    @media (min-width: 1500px) {\n      right: ", ";\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", ";\n\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    height: ", ";\n    border-radius: ", ";\n    box-shadow: none;\n    margin: 0;\n    margin-bottom: 2px;\n\n    ", " {\n      font-size: 8px;\n    }\n\n    ", " {\n      font-size: 8px;\n      line-height: 10px;\n    }\n\n    ", " {\n      height: 6px;\n      width: 4px;\n      background-size: contain;\n      margin-right: 4px;\n      top: 0;\n    }\n\n    .tooltip-trigger-text {\n      display: none;\n    }\n\n    ", " {\n      font-size: 6px;\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 8px;\n    ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.04);\n    border-radius: ", ";\n    z-index: 1;\n\n    &:hover {\n      box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.07);\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.02);\n    padding: 6px;\n    z-index: 2;\n\n    @supports(position: -webkit-sticky) {\n      top: 0;\n      position: -webkit-sticky;\n    }\n\n    @supports(position: sticky) {\n      top: 0;\n      position: sticky;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    height: auto;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background: white;\n  height: ", ";\n  overflow: hidden;\n  margin-bottom: 8px;\n  transform: translateY(0px);\n  transition: all 0.3s cubic-bezier(0.22, 0.61, 0.36, 1);\n  font-size: 12px;\n  line-height: 17px;\n  color: #343434;\n  ", ";\n  text-align: center;\n  cursor: ", ";\n\n  ", "\n\n  ", "\n\n  ", ";\n\n  ", ";\n\n  &:after {\n    content: '';\n    ", ";\n    width: ", ";\n    background: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n    height: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin: auto;\n  padding: 28px;\n  height: ", ";\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SIDEBAR_WIDTH = 260;
var SIDEBAR_WIDTH_1300 = 300;
var SIDEBAR_WIDTH_1500 = 340;
var CONTAINER_PADDING = 8;
var HEADER_HEIGHT = 70;
var PRINT_VIEW_HEIGHT = 40;
var DEFAULT_ROW_HEIGHT = 70;

var getRowHeight = function getRowHeight(height, header, printView) {
  if (printView) {
    return "".concat(PRINT_VIEW_HEIGHT, "px");
  }

  if (height) {
    return "".concat(height, "px");
  } else if (header) {
    return "".concat(HEADER_HEIGHT, "px");
  }

  return "".concat(DEFAULT_ROW_HEIGHT, "px");
};

var StyledTableContainer = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var fixedHeight = _ref.fixedHeight;
  return fixedHeight ? "".concat(fixedHeight, "px") : 'auto';
}, function (_ref2) {
  var printView = _ref2.printView;
  return printView && (0, _styledComponents.css)(_templateObject2());
});

exports.StyledTableContainer = StyledTableContainer;

var StyledRow = _styledComponents["default"].div(_templateObject3(), function (_ref3) {
  var height = _ref3.height,
      header = _ref3.header,
      printView = _ref3.printView;
  return getRowHeight(height, header, printView);
}, _knotchincWebReactComponentsUtils.contentCentered, function (_ref4) {
  var hasClick = _ref4.hasClick;
  return hasClick ? 'pointer' : 'default';
}, function (_ref5) {
  var allowMultiline = _ref5.allowMultiline;
  return allowMultiline && (0, _styledComponents.css)(_templateObject4());
}, function (_ref6) {
  var header = _ref6.header,
      printView = _ref6.printView;
  return header && !printView ? (0, _styledComponents.css)(_templateObject5()) : (0, _styledComponents.css)(_templateObject6(), !printView && '5px');
}, function (_ref7) {
  var hasSideBar = _ref7.hasSideBar,
      header = _ref7.header;
  return hasSideBar && (0, _styledComponents.css)(_templateObject7(), header ? 'padding: 6px 10px 6px 0px' : 'padding-right: 6px');
}, function (_ref8) {
  var printView = _ref8.printView,
      header = _ref8.header;
  return printView && (0, _styledComponents.css)(_templateObject8(), header ? '20px' : '40px', header ? '0 0 5px 5px' : '5px', _styled.StyledCell, _styled.HeaderCell, _styled.NumUnitIcon, _styled.RankContainer);
}, (0, _knotchincWebReactComponentsUtils.absFull)('15%', 'auto', '15%', 0), function (_ref9) {
  var current = _ref9.current;
  return current ? '3px' : '0';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.palette[7];
});

exports.StyledRow = StyledRow;

var StyledTable = _styledComponents["default"].div(_templateObject9(), function (_ref11) {
  var fixedHeight = _ref11.fixedHeight,
      sideBar = _ref11.sideBar;
  return (fixedHeight || sideBar) && (0, _styledComponents.css)(_templateObject10(), CONTAINER_PADDING, CONTAINER_PADDING, CONTAINER_PADDING, sideBar ? "".concat(SIDEBAR_WIDTH + CONTAINER_PADDING, "px") : "".concat(CONTAINER_PADDING, "px"), sideBar ? "".concat(SIDEBAR_WIDTH_1300 + CONTAINER_PADDING, "px") : "".concat(CONTAINER_PADDING, "px"), sideBar ? "".concat(SIDEBAR_WIDTH_1500 + CONTAINER_PADDING, "px") : "".concat(CONTAINER_PADDING, "px"));
}, function (_ref12) {
  var printView = _ref12.printView;
  return printView && (0, _styledComponents.css)(_templateObject11());
});

exports.StyledTable = StyledTable;

var StyledTableBody = _styledComponents["default"].div(_templateObject12(), function (_ref13) {
  var fixedHeight = _ref13.fixedHeight;
  return fixedHeight ? "".concat(fixedHeight - 2 * CONTAINER_PADDING - HEADER_HEIGHT, "px") : 'auto';
}, function (_ref14) {
  var printView = _ref14.printView;
  return printView && (0, _styledComponents.css)(_templateObject13());
});

exports.StyledTableBody = StyledTableBody;

var StyledSideBar = _styledComponents["default"].div(_templateObject14(), CONTAINER_PADDING, CONTAINER_PADDING, CONTAINER_PADDING, SIDEBAR_WIDTH, SIDEBAR_WIDTH_1300, SIDEBAR_WIDTH_1500);

exports.StyledSideBar = StyledSideBar;

//# sourceMappingURL=styled.js.map